import React from "react";
import { lePetitPrinceImages } from "../../../../../Assets/images/le-petit-prince";
import StyledDiv from "../../../../StyledDiv/StyledDiv";
import { IStyledDivStyles } from "../../../../StyledDiv/StyledDiv";

interface IPlanetteBeigeProps {
  styles?: IStyledDivStyles;
}

const PlanetteBeige = ({ styles }: IPlanetteBeigeProps) => {
  return (
    <StyledDiv styles={styles}>
      <img
        src={lePetitPrinceImages.planetteBeige}
        alt="Beige planet"
      />
    </StyledDiv>
  );
};

export default PlanetteBeige;
